import { HttpClient } from '@shared/adapters/HttpClient';
import { OrderDetailsApiResponse } from '../models/OrderDetails';

export interface OrderDetailsFilters {
  ids?: number[];
  page?: number;
  per_page?: number;
}

export class OrderDetailsApiAdapter {
  constructor(private httpClient: HttpClient) {}

  async getOrdersByIds(orderIds: number[]): Promise<OrderDetailsApiResponse> {
    const idsParam = orderIds.join(',');
    const response = await this.httpClient.get<OrderDetailsApiResponse>(`/orders?ids=${idsParam}`);
    return response;
  }

  async getOrdersByIdsPaginated(filters: OrderDetailsFilters): Promise<OrderDetailsApiResponse> {
    const { ids = [], page = 1, per_page = 100 } = filters;

    const params = new URLSearchParams();

    if (ids.length > 0) {
      params.append('ids', ids.join(','));
    }

    params.append('page', page.toString());
    params.append('per_page', per_page.toString());

    // Solo mostrar loading global para la primera página
    const showGlobalLoading = page === 1;
    const response = await this.httpClient.get<OrderDetailsApiResponse>(
      `/orders?${params.toString()}`,
      {},
      {},
      showGlobalLoading,
    );
    return response;
  }
}
